export default __webpack_public_path__ + "static/media/user-inactive.ec7b270a.png";